export const EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const EMAIL_MAX_LENGTH = 254;
export const polygonClipPath = `polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)`;
export const USA_NATIONALITY_CODE = 'US';

export const REGISTRATION_URL = 'https://registration.gammaprime.com/register';
export const QR_PARAM_NAME = 'participant';
